import {
  call, put, takeEvery, all, fork, select,
} from 'redux-saga/effects';
import { api } from '../../helpers/api';
import {
  activeAuthKeyRequest, activeAuthKeySuccess,
  getConnectedEndpointsToAuthKeysRequest, getConnectedEndpointsToAuthKeysSuccess
} from './actions';
import { createToastRequest } from '../toasts/actions';
import {
  refreshRequest,
} from '../auth/actions';
import { ActiveAuthKey } from './constants';
import history from '../../history';

const getAuth = (state) => state.auth?.auth;

export function* fetchActiveAuthKey(ops) {
  const { data } = ops;
  const authData = yield select(getAuth);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, `/auth-keys/${data.id}`, 'GET', null, authData.access_token);
      if (response.ok) {
        const parsed = yield response.json();
        yield put(activeAuthKeySuccess(parsed));
      } else if (response.status === 401) {
        yield put(refreshRequest(activeAuthKeyRequest, data));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

export function* getConnectedEndpointsToAuthKeys(ops) {
  const { data, callback } = ops;
  const authData = yield select(getAuth);

  try {
    if (!authData?.access_token) {
      history.push('/login');
    } else {
      const response = yield call(api, `/auth-keys-link?keyId=${data.id}`, 'GET', null, authData.access_token);
      if (response.ok) {
        const parsed = yield response.json();
        yield put(getConnectedEndpointsToAuthKeysSuccess(parsed.items));
        if (callback) callback(parsed.items);
      } else if (response.status === 401) {
        yield put(refreshRequest(getConnectedEndpointsToAuthKeysRequest, data));
      } else {
        const parsed = yield response.json();
        yield put(createToastRequest({ type: 'error', text: parsed?.error, code: parsed?.code }));
      }
    }
  } catch (e) {
    yield put(createToastRequest({ type: 'error', text: 'Unexpected Error' }));
  }
}

function* activeAuthKeySaga() {
  yield takeEvery(ActiveAuthKey.activeAuthKeyRequest, fetchActiveAuthKey);
  yield takeEvery(ActiveAuthKey.getConnectedEndpointsToAuthKeysRequest, getConnectedEndpointsToAuthKeys);
}

function* configSaga() {
  yield all([fork(activeAuthKeySaga)]);
}

export default configSaga;
